window.lsCloud.analytics = {
  record() {
    // Google Analytics
    if (typeof window.ga !== 'undefined') {
      window.ga('send', 'pageview');
    }
  },

  removeBadParams(params) {
    delete params.id;
    delete params.redirect_after_login;
    return params;
  },

  track(event, data, prefix) {
    if (window.Analytics) {
      window.Analytics.track(event, data, prefix);
    }
  },

  event: {
    changeUnitCost(transactionId, transactionLineId, unitCost) {
      window.lsCloud.analytics.track('Change Unit Cost Line Item', {
        saleID: transactionId,
        saleLineID: transactionLineId,
        unitCost,
      });
    },
  },
};
